import styles from './QuizDetailsModal.module.css';
import giftBox from './giftBox.png';
const QuizRewards = ({event}) => {
    return (<>{event?.prize1 &&
        <div className={styles.quizRewards}>
            <div className={styles.quizRewardsWrapper}>
                <img src={giftBox} alt="Gift" width={48} height={48} className={styles.giftBox} />
                <div className={styles.rewardsHeader}>
                    <h4>বিজয়ীদের জন্য উপহার</h4>
                </div>
                <div className={styles.rewardsList}>
                    {event?.prize1 && <div className={styles.rewardItem}>
                        <span>🏆 {event?.prize1}</span>
                    </div>}
                    {event?.prize2 && <div className={styles.rewardItem}>
                        <span>🏆 {event?.prize2}</span>
                    </div>}
                    {event?.prize3 && event.prize3.split('<br>').map((prize, idx) => (
                        <div className={styles.rewardItem} key={idx}>
                            <span>🏆 {prize.trim()}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>}
    </>)
}

export default QuizRewards